(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[95405,40659,81066,75847,44709,40852,81243,74453,44954,40617,19341,97],{

/***/ 75557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(58665);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ shaders; },
/* harmony export */   "l": function() { return /* binding */ animationTypes; }
/* harmony export */ });
var animationTypes = [
    "appear",
    "getTogether",
    "pagination"
];
var shaders = {
    vs: "\n      uniform float scale;\n      uniform vec3 mouse;\n\n      varying vec2 vUv;\n\n      void main(){\n        vUv = uv;\n        vec3 newpos = position;\n        vec3 dir = newpos - mouse;\n        float distance = length(dir);\n        float radius = 3.;\n\n        if(distance < radius){\n            float ratio = 1. - distance / radius;\n            newpos -= dir * (ratio * ratio);\n        }\n\n        vec4 mvPosition = modelViewMatrix * vec4(newpos, 1.0);\n        gl_PointSize = 10000. * (1. / - mvPosition.z);\n        gl_Position = projectionMatrix * mvPosition;\n      }\n",
    fs: "\n      varying vec2 vUv;\n\n      void main(){\n        \n        vec2 uv = vUv;\n        gl_FragColor = vec4(1.0, 0.9, 0.01, 1.0);\n      }\n"
};


/***/ }),

/***/ 60982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ three; },
/* harmony export */   "y": function() { return /* binding */ slogan; }
/* harmony export */ });
/* harmony import */ var utils_threeModule__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1217);
/* harmony import */ var utils_threeModule__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82854);
/* harmony import */ var utils_threeModule__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99477);
/* harmony import */ var animejs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76030);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96076);
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4902);




var three = {
    loadModel: function(callback) {
        var loader = new utils_threeModule__WEBPACK_IMPORTED_MODULE_1__/* .GLTFLoader */ .E();
        var dracoLoader = new utils_threeModule__WEBPACK_IMPORTED_MODULE_2__/* .DRACOLoader */ ._();
        dracoLoader.setDecoderPath("/draco/gltf/");
        loader.setDRACOLoader(dracoLoader);
        loader.load("/models/Duck_2.gltf", function(gltf) {
            callback(gltf.scene);
        });
    },
    /* ------------------------ */ combineBuffer: function(model, bufferName) {
        var count = 0;
        model.traverse(function(child) {
            if (child.isMesh) {
                var buffer = child.geometry.attributes[bufferName];
                count += buffer.array.length;
            }
        });
        var combined = new Float32Array(count);
        var localOffset = 0;
        model.traverse(function(child) {
            if (child.isMesh) {
                var buffer = child.geometry.attributes[bufferName];
                combined.set(buffer.array, localOffset);
                localOffset += buffer.array.length;
            }
        });
        return new utils_threeModule__WEBPACK_IMPORTED_MODULE_3__/* .BufferAttribute */ .TlE(combined, 3);
    },
    /* ------------------------ */ createCamera: function(isMobile) {
        var createdCamera = new utils_threeModule__WEBPACK_IMPORTED_MODULE_3__/* .PerspectiveCamera */ .cPb(10, window.innerWidth / window.innerHeight, 1, 50000);
        var createdScene = new utils_threeModule__WEBPACK_IMPORTED_MODULE_3__/* .Scene */ .xsS();
        if (isMobile) createdCamera.position.set(6000, 0, 0);
        else createdCamera.position.set(0, 0, 5000);
        createdCamera.lookAt(createdScene.position);
        return {
            createdCamera: createdCamera,
            createdScene: createdScene
        };
    },
    /* ------------------------ */ creatMat: function() {
        return new utils_threeModule__WEBPACK_IMPORTED_MODULE_3__/* .ShaderMaterial */ .jyz({
            uniforms: {
                time: {
                    type: "f",
                    value: 0
                },
                resolution: {
                    type: "v2",
                    value: new utils_threeModule__WEBPACK_IMPORTED_MODULE_3__/* .Vector2 */ .FM8(window.innerWidth, window.innerHeight)
                },
                mouse: {
                    type: "v3",
                    value: new utils_threeModule__WEBPACK_IMPORTED_MODULE_3__/* .Vector3 */ .Pa4(0, 0, 0)
                },
                scale: {
                    type: "f",
                    value: window.innerHeight / 2
                }
            },
            vertexShader: _constant__WEBPACK_IMPORTED_MODULE_4__/* .shaders.vs */ .D.vs,
            fragmentShader: _constant__WEBPACK_IMPORTED_MODULE_4__/* .shaders.fs */ .D.fs
        });
    },
    /* ------------------------ */ createMesh: function(positions, scene, isMobile, originals, clones, mat, options, meshes, meshClones) {
        var geometry = new utils_threeModule__WEBPACK_IMPORTED_MODULE_3__/* .BufferGeometry */ .u9r();
        geometry.setAttribute("position", positions.clone());
        geometry.setAttribute("initialPosition", positions.clone());
        geometry.attributes.position.setUsage(utils_threeModule__WEBPACK_IMPORTED_MODULE_3__/* .DynamicDrawUsage */ .dj0);
        // geometry.addAttribute('position', positions.clone());
        // geometry.addAttribute('initialPosition', positions.clone());
        // TODO geometry.attributes.positions.setDynamic(true);
        if (isMobile) {
            if (window.innerHeight <= 700) {
                originals = [
                    {
                        positions: {
                            x: 0,
                            y: 100,
                            z: 0
                        }
                    }
                ];
            }
            if (window.innerHeight > 700 && window.innerHeight <= 800) {
                originals = [
                    {
                        positions: {
                            x: 0,
                            y: 150,
                            z: 0
                        }
                    }
                ];
            }
            if (window.innerHeight > 800) {
                originals = [
                    {
                        positions: {
                            x: 0,
                            y: 100,
                            z: 0
                        }
                    }
                ];
            }
            options.default.meshRotationY = 1.5;
        } else {
            originals = [
                {
                    positions: {
                        x: 0,
                        y: 0,
                        z: 0
                    }
                }
            ];
        }
        clones = [
            {
                positions: {
                    x: 0,
                    y: 0,
                    z: 0
                },
                color: {
                    r: 252,
                    g: 3,
                    b: 3
                },
                opacity: 0.0
            },
            {
                positions: {
                    x: 0,
                    y: 0,
                    z: 0
                },
                color: {
                    r: 2,
                    g: 219,
                    b: 35
                },
                opacity: 0.0
            },
            {
                positions: {
                    x: 0,
                    y: 0,
                    z: 0
                },
                color: {
                    r: 25,
                    g: 0,
                    b: 247
                },
                opacity: 0.0
            }, 
        ];
        originals.forEach(function(original) {
            var mesh = new utils_threeModule__WEBPACK_IMPORTED_MODULE_3__/* .Points */ .woe(geometry, mat);
            mesh.scale.x = options.default.meshScale;
            mesh.scale.y = options.default.meshScale;
            mesh.scale.z = options.default.meshScale;
            mesh.position.x = options.default.meshPositionX + original.positions.x;
            mesh.position.y = options.default.meshPositionY + original.positions.y;
            mesh.position.z = options.default.meshPositionZ + original.positions.z;
            mesh.rotation.x = options.default.meshRotationX;
            mesh.rotation.y = options.default.meshRotationY;
            mesh.rotation.z = options.default.meshRotationZ;
            scene.add(mesh);
            if (meshes.length <= 2) {
                meshes.push(mesh);
            }
        });
        clones.forEach(function(clone) {
            var mesh = new utils_threeModule__WEBPACK_IMPORTED_MODULE_3__/* .Points */ .woe(geometry, new utils_threeModule__WEBPACK_IMPORTED_MODULE_3__/* .PointsMaterial */ .UY4({
                size: 10
            }));
            mesh.position.x = options.default.meshPositionX + clone.positions.x;
            mesh.position.y = options.default.meshPositionY + clone.positions.y;
            mesh.position.z = options.default.meshPositionZ + clone.positions.z;
            mesh.rotation.x = options.default.meshRotationX;
            mesh.rotation.y = options.default.meshRotationY;
            mesh.rotation.z = options.default.meshRotationZ;
            mesh.material.color = new utils_threeModule__WEBPACK_IMPORTED_MODULE_3__/* .Color */ .Ilk("rgb(".concat(clone.color.r, ", ").concat(clone.color.g, ", ").concat(clone.color.b, ")"));
            mesh.material.transparent = true;
            mesh.material.opacity = clone.opacity;
            scene.add(mesh);
            if (meshes.length <= 2) {
                meshClones.push(mesh);
            }
        });
    },
    /* ------------------------ */ createRenderer: function() {
        var renderer = new utils_threeModule__WEBPACK_IMPORTED_MODULE_3__/* .WebGLRenderer */ .CP7({
            alpha: true,
            antialias: true,
            powerPreference: "high-performance"
        });
        renderer.setPixelRatio(window.devicePixelRatio);
        renderer.setSize(document.documentElement.clientWidth, window.innerHeight);
        renderer.setClearColor(0x000000, 0);
        renderer.autoClear = false;
        return renderer;
    },
    /* ------------------------ */ setRandomPosition: function(mesh, scatterStep) {
        var positions = mesh.geometry.attributes.position;
        var count = positions.count;
        for(var i = 0; i < count; i += 1){
            if (scatterStep < 0.0125) {
                scatterStep += 0.01;
            }
            positions.setXYZ(i, positions.getX(i) + Math.random() * (Math.random() * scatterStep - scatterStep / 2), positions.getY(i) + Math.random() * (Math.random() * scatterStep - scatterStep / 2), positions.getZ(i) + Math.random() * (Math.random() * scatterStep - scatterStep / 2));
        }
        positions.needsUpdate = true;
    },
    /* ------------------------ */ setRotateAnimation: function(mesh, options) {
        if (options.initial.rotationDirection === "left") {
            if (mesh.rotation.y > 0) mesh.rotation.y += -0.1 * options.default.rotationSpeed;
            else options.initial.rotationDirection = "right";
        }
        if (options.initial.rotationDirection === "right") {
            if (mesh.rotation.y > -3) mesh.rotation.y -= -0.1 * options.default.rotationSpeed;
            else options.initial.rotationDirection = "left";
        }
    }
};
var slogan = {
    sloganOpacityAnimation: function(finalOpacity) {
        animejs__WEBPACK_IMPORTED_MODULE_0__/* ["default"].timeline */ .Z.timeline({
            loop: false
        }).add({
            targets: ".letter-container .letter",
            opacity: [
                0,
                1
            ],
            easing: "easeInOutQuad",
            duration: 2250,
            delay: function(el, i) {
                return 150 * (i + 1);
            }
        }).add({
            targets: ".intro-text",
            opacity: [
                0,
                1
            ],
            easing: "easeInOutQuad",
            duration: 1000
        }).add({
            targets: ".letter-container",
            opacity: finalOpacity,
            duration: 1000,
            easing: "easeOutExpo",
            delay: 0
        });
    },
    /* ------------------------ */ sloganBlurAnimation: function(sloganRef, finalOpacity, styles) {
        var test = function() {
            if (sloganRef.current) sloganRef.current.classList.add(styles);
        };
        animejs__WEBPACK_IMPORTED_MODULE_0__/* ["default"].timeline */ .Z.timeline({
            loop: false
        }).add({
            targets: ".letter-container",
            opacity: finalOpacity,
            duration: 1000,
            easing: "easeOutExpo",
            delay: 500,
            complete: function() {
                return test();
            }
        }).add({
            targets: ".intro-text",
            opacity: [
                0,
                1
            ],
            easing: "easeInOutQuad",
            duration: 500
        });
    },
    /* ------------------------ */ animateSlogan: function(sloganRef) {
        // TODO: Fix hydration re-render issue to avoid second call of this function (second condition could be deleted right after fix)
        if ((sloganRef === null || sloganRef === void 0 ? void 0 : sloganRef.current) && sloganRef.current.innerHTML === utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .HOMEPAGE_SLOGAN */ .Z6) {
            var str = sloganRef.current.innerHTML;
            var newStr = "";
            for(var i = 0; i < str.length; i += 1){
                if (str[i] === " ") newStr += " ";
                else if (str[i] === "\n") newStr += "</br>";
                else newStr += "<span class='letter'>".concat(str[i], "</span>");
            }
            sloganRef.current.innerHTML = newStr;
        }
    },
    /* ------------------------ */ setSloganOpacity: function(sloganRef, isMobile) {
        var pageYOffset = window.pageYOffset, innerHeight = window.innerHeight;
        var newOpacity = pageYOffset / innerHeight;
        if (sloganRef.current) {
            if (!isMobile) {
                sloganRef.current.style.opacity = 0.1 - 0.25 * newOpacity;
            } else {
                sloganRef.current.style.opacity = 1 - 2.7 * newOpacity;
            }
        }
    },
    /* ------------------------ */ setOpacity: function(canvas, containerCanvas) {
        var pageYOffset = window.pageYOffset, innerHeight = window.innerHeight;
        if (canvas) {
            var ratio = pageYOffset / innerHeight;
            canvas.style.opacity = 1 - 1.4 * ratio;
        }
        if (containerCanvas && containerCanvas.current) {
            var ratio1 = pageYOffset / innerHeight;
            containerCanvas.current.style.opacity = 1 - 1.4 * ratio1;
        }
    }
};


/***/ }),

/***/ 40659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Common_LinkWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./utils/ga.js
var ga = __webpack_require__(48114);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
;// CONCATENATED MODULE: ./components/Common/LinkWrapper/helpers/index.js
var isAbsoluteUrl = function(path) {
    try {
        var _ = new URL(path);
        return true;
    } catch (e) {
        return false;
    }
};

// EXTERNAL MODULE: ./components/Common/LinkWrapper/styles.module.scss
var styles_module = __webpack_require__(81098);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./components/Common/LinkWrapper/index.jsx










var LinkWrapper = function(param) {
    var path = param.path, className = param.className, children = param.children, googleAnalyticProps = param.googleAnalyticProps, isSocialLink = param.isSocialLink, onClick = param.onClick;
    var isAbsoluteLink = (0,react.useMemo)(function() {
        return isAbsoluteUrl(path);
    }, [
        path
    ]);
    var isLocalLink = !isAbsoluteLink || path.includes(constants/* CUSTOM_DOMAIN */.zq);
    if (!path) {
        return children;
    }
    var target = !isLocalLink ? "_blank" : undefined;
    var rel = isSocialLink || isLocalLink ? undefined : "noopener noreferrer nofollow";
    var href = !isAbsoluteLink && path[0] !== "/" ? "/".concat(path) : path;
    var handleOnClick = function(e) {
        if (!isEmpty_default()(googleAnalyticProps)) {
            var category = googleAnalyticProps.category, action = googleAnalyticProps.action, label = googleAnalyticProps.label, data = googleAnalyticProps.data;
            ga/* default.trackEvent */.Z.trackEvent(category || data, action || data, label || data);
        }
        onClick(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        /* TODO: if you need to instantly open pages via links in the navigation,
      you can remove this code to enable link page generation and loading. However, performance will be degraded
      more: https://nextjs.org/docs/api-reference/next/link */ prefetch: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: classnames_default()((styles_module_default()).link, className),
            onClick: handleOnClick,
            target: target,
            rel: rel,
            children: children
        })
    });
};
LinkWrapper.defaultProps = {
    path: null,
    className: null,
    googleAnalyticProps: {},
    children: null,
    isSocialLink: false,
    onClick: function() {}
};
LinkWrapper.propTypes = {
    path: (prop_types_default()).string,
    className: (prop_types_default()).string,
    googleAnalyticProps: prop_types_default().instanceOf(Object),
    children: (prop_types_default()).node,
    isSocialLink: (prop_types_default()).bool,
    onClick: (prop_types_default()).func
};
/* harmony default export */ var Common_LinkWrapper = (LinkWrapper);


/***/ }),

/***/ 38067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Common_MetaTags; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./utils/microdata/data.js
var data = __webpack_require__(13107);
// EXTERNAL MODULE: ./utils/microdata/utils.js
var utils = __webpack_require__(20281);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./utils/microdata/deprecatedData.js




var _obj;
// TODO: Replace with actual data ASAP
var deprecatedData = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.softwareDevelopmentPrice.slug */.y2.softwareDevelopmentPrice.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Pricing: Hire a Team for Your Project | Yellow",
    description: "Calculate how much money you will need to build your software.\n    We only bill for the time actually spent on work, so it's easy to manage the budget. No extra fees.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.penetrationTesting.slug */.y2.penetrationTesting.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Penetration testing  | Yellow",
    description: "Use penetration testing to make sure your software solution is safe for your users. " + "Yellow will provide you with penetration testing services.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.customMobileApp.slug */.y2.customMobileApp.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Custom mobile app development company | Yellow",
    description: "The best talents for Mobile App Development are here. Hire an experienced team to work on your idea.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.iosDevelopmentServices.slug */.y2.iosDevelopmentServices.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "iOS Mobile App Development Company | Yellow",
    description: "Yellow can provide you with iOS development services. If you want to create an iPhone or " + "iPad app, we are here to help.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.androidDevelopmentServices.slug */.y2.androidDevelopmentServices.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Custom Android App Development Company | Yellow",
    description: "Yellow is ready to provide you with Android development services to bring your idea to life.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.prototypingServices.slug */.y2.prototypingServices.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Mobile App Prototyping Services | Yellow",
    description: "Prototyping is an important stage in mobile app development. Complete it with Yellow!",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.customWebApp.slug */.y2.customWebApp.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Web Application Development Services | Yellow",
    description: "Our team is ready to provide you with web development services. " + "We are working with websites, PWAs, chatting applications, and landing pages.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.softwareQualityAssuranceServices.slug */.y2.softwareQualityAssuranceServices.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Software Quality Assurance and Testing Services | Yellow",
    description: "Quality assurance is an important part of software product creation since it ensures that users" + " will receive a convenient and fully-functional solution. If you need QA services, Yellow is ready to provide them!",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.crowdfundingPlatform.slug */.y2.crowdfundingPlatform.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Crowdfunding Platform Development Company | Yellow",
    description: "Yellow is ready to provide you with crowdfunding platform development services. " + "High quality, realistic budget estimate, fast speed.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.fintechDevelopment.slug */.y2.fintechDevelopment.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Fintech Software Development Services | Yellow",
    description: "The fintech industry is booming and doesn't seem to stop. Let's see how your " + "idea can take the slice of pie?",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.designServices.slug */.y2.designServices.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "UI/UX design services | Yellow",
    description: "Visual content matters, that is where UI/UX design comes into play.Users love good-looking " + "software. Make mobile your app or website captivating with Yellow.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.discoveryPhase.slug */.y2.discoveryPhase.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Project Discovery Phase in Custom Software Development | Yellow",
    description: "Discovery phase of a project is an important part of software development. " + "Learn more about how Yellow runs a discovery phase to benefit your business."
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.eWalletAppDevelopment.slug */.y2.eWalletAppDevelopment.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "E-Wallet App Development Company | Yellow",
    description: "Mobile e-wallet app development services for any industry and any business scale.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.bankingSoftwareDevelopmentCompany.slug */.y2.bankingSoftwareDevelopmentCompany.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Banking Software Development Company | Yellow",
    description: "We provide companies and organizations big and small with outstanding banking software " + "development. Check out what we can do for you.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.deliveryQualityInYellow.slug */.y2.deliveryQualityInYellow.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "What Makes Yellow a Good Software Development Partner | Yellow",
    description: "Delivery quality standards we follow to build a perfect project for YOU.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.pwaDevelopmentServices.slug */.y2.pwaDevelopmentServices.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "PWA Development Services | Yellow",
    description: "Yellow is combining web and mobile worlds and creates progressive web " + "apps that function smoothly on all devices.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.paymentGatewayDevelopment.slug */.y2.paymentGatewayDevelopment.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Payment Software Gateway Development Company | Yellow",
    description: "Yellow is a leading Payment Gateway Development company, providing customized " + "solutions to enhance transaction security and accuracy. Read more about our services now.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.billingSoftwareDevelopment.slug */.y2.billingSoftwareDevelopment.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Billing Software Development Services Company | Yellow",
    description: "If you want to create brand-new billing software, partner with Yellow and build a top-tier solution.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.crossPlatformDevelopmentServices.slug */.y2.crossPlatformDevelopmentServices.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Cross-Platform App Development Services | Yellow",
    description: "Your cross-platform application will rock the stage and Yellow is ready to make it happen.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.devOpsDevelopment.slug */.y2.devOpsDevelopment.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "DevOps Development Company | Yellow",
    description: "If your company wants to integrate DevOps service into its processes and get all " + "the benefits this technology offers, Yellow is ready to lend a hand!",
    image: data/* logoUrl */.pt
}), _obj);

;// CONCATENATED MODULE: ./utils/microdata/index.js






function getPageMicrodata(page) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, breadcrumbs = ref.breadcrumbs, microData = ref.microData;
    var microdataArray = [
        // TODO: uncomment when deprecated data will be replaced
        // webpageMicrodata,
        data/* websiteMicrodata */.IR,
        data/* organisationMicrodata */.nW, 
    ];
    var breadcrumbsMicrodata = (0,utils/* getBreadcrumbsMicrodata */.js)(breadcrumbs);
    if (breadcrumbsMicrodata) {
        microdataArray.push(breadcrumbsMicrodata);
    }
    switch(page){
        case constants/* ROUTES.homepage.slug */.y2.homepage.slug:
        case constants/* ROUTES.contact.slug */.y2.contact.slug:
            microdataArray.push(data/* localBusinessMicrodata */._c);
            microdataArray.push(data/* professionalServiceMicrodata */.jh);
            break;
        case constants/* ROUTES.company.slug */.y2.company.slug:
        case constants/* ROUTES.whyUs.slug */.y2.whyUs.slug:
            microdataArray.push(data/* localBusinessMicrodata */._c);
            microdataArray.push(data/* professionalServiceMicrodata */.jh);
            microdataArray.push(data/* aboutPageMicrodata */.WN);
            break;
        case constants/* ROUTES.blog.slug */.y2.blog.slug:
        case constants/* ROUTES.portfolio.slug */.y2.portfolio.slug:
        case constants/* ROUTES.project.slug */.y2.project.slug:
        case constants/* ROUTES.process.slug */.y2.process.slug:
        case constants/* ROUTES.termsAndConditions.slug */.y2.termsAndConditions.slug:
        case constants/* ROUTES.cookiesPolicy.slug */.y2.cookiesPolicy.slug:
        case constants/* ROUTES.privacyPolicy.slug */.y2.privacyPolicy.slug:
            break;
        case constants/* ROUTES.article.slug */.y2.article.slug:
            microdataArray.push((0,utils/* getArticleMicrodata */.WK)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, microData), {
                organisationMicrodata: data/* organisationMicrodata */.nW
            })));
            break;
        case constants/* ROUTES.person.slug */.y2.person.slug:
            microdataArray.push((0,utils/* getPersonMicrodata */.RK)(microData));
            break;
        default:
            var currentRoute = Object.values(constants/* ROUTES */.y2).find(function(route) {
                return route.slug === page;
            });
            var oldData = deprecatedData[page];
            if (oldData) {
                microdataArray.push(oldData);
                break;
            }
            microdataArray.push((0,utils/* getServiceMicrodata */.fi)(currentRoute, {
                organisationMicrodata: data/* organisationMicrodata */.nW,
                category: data/* CATEGORY */.En[page],
                offers: data/* OFFERS */.jn[page],
                addresses: data/* addresses */.UB
            }));
            break;
    }
    return microdataArray;
}

;// CONCATENATED MODULE: ./components/Common/MetaTags/utils/data.js
var defaultMetadata = {
    title: "Trusted AI Transformation Agency | Yellow",
    description: "We help businesses turn their AI initiatives into production-grade solutions with measurable results."
};

;// CONCATENATED MODULE: ./components/Common/MetaTags/index.jsx
/* eslint-disable react/jsx-max-props-per-line */ 






var MetaTags = function(param) {
    var page = param.page, pageMetadata = param.pageMetadata, children = param.children, breadcrumbs = param.breadcrumbs, microData = param.microData, isArticle = param.isArticle;
    var metaTitle = pageMetadata.metaTitle, metaDescription = pageMetadata.metaDescription, metaRobots = pageMetadata.metaRobots, image = pageMetadata.image, publishedAt = pageMetadata.publishedAt, categoryTag = pageMetadata.categoryTag, keyWords = pageMetadata.keyWords, pageNumber = pageMetadata.pageNumber, url = pageMetadata.url, ogImage = pageMetadata.ogImage;
    var microdata = getPageMicrodata(page, {
        breadcrumbs: breadcrumbs,
        microData: microData
    });
    var getTitle = function() {
        return pageNumber > 1 ? "".concat(metaTitle || defaultMetadata.title, " | Page ").concat(pageNumber) : metaTitle || defaultMetadata.title;
    };
    var getDescription = function() {
        return pageNumber > 1 ? "".concat(metaDescription || defaultMetadata.description, " | Page ").concat(pageNumber) : metaDescription || defaultMetadata.description;
    };
    var getImage = function() {
        if (ogImage) return ogImage;
        if (isArticle) return image;
        return (0,helper/* getPathWithCdn */.d6)("/apple-touch-icon.png");
    };
    var date = isArticle ? publishedAt : new Date();
    var type = isArticle ? "article" : "website";
    var title = getTitle();
    var description = getDescription();
    var robots = !constants/* IS_PROD */.XK ? "none" : metaRobots;
    return(// eslint-disable-next-line @next/next/no-script-component-in-head
    /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "date",
                content: date
            }),
            robots && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "robots",
                content: robots
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "canonical",
                href: url
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:locale",
                content: "en_US"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:type",
                content: type
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: getImage()
            }),
            categoryTag && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "article:section",
                content: categoryTag
            }),
            publishedAt && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "article:published_time",
                content: publishedAt
            }),
            keyWords === null || keyWords === void 0 ? void 0 : keyWords.map(function(keyWord) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "article:tag",
                    content: keyWord
                }, "meta/tag/".concat(keyWord));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "viewport",
                content: "initial-scale=1.0, width=device-width"
            }, "viewport"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "shortcut icon",
                href: (0,helper/* getPathWithCdn */.d6)("/yellow_logo.ico")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "180x180",
                href: (0,helper/* getPathWithCdn */.d6)("/apple-touch-icon.png")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "mask-icon",
                href: (0,helper/* getPathWithCdn */.d6)("/safari-pinned-tab.svg"),
                color: "#ffbf02"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "manifest",
                href: "/manifest.json"
            }),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                id: "application/ld+json/microdata",
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(microdata, null, 2)
                }
            })
        ]
    }));
};
MetaTags.defaultProps = {
    children: null,
    pageMetadata: {},
    articleData: {},
    breadcrumbs: [],
    isArticle: false
};
MetaTags.propTypes = {
    page: (prop_types_default()).string.isRequired,
    breadcrumbs: prop_types_default().instanceOf(Array),
    articleData: prop_types_default().instanceOf(Object),
    pageMetadata: prop_types_default().shape({
        metaTitle: (prop_types_default()).string,
        metaDescription: (prop_types_default()).string,
        metaRobots: (prop_types_default()).string,
        image: (prop_types_default()).string,
        ogImage: (prop_types_default()).string,
        publishedAt: (prop_types_default()).string,
        categoryTag: (prop_types_default()).string,
        keyWords: prop_types_default().instanceOf(Array),
        pageNumber: (prop_types_default()).number
    }),
    children: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).array,
        (prop_types_default()).element, 
    ]),
    isArticle: (prop_types_default()).bool,
    defaultMetaData: prop_types_default().instanceOf(Array)
};
/* harmony default export */ var Common_MetaTags = (MetaTags);


/***/ }),

/***/ 58665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/HomeCommon/ScrollIcon/styles.module.scss
var styles_module = __webpack_require__(21917);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./components/HomeCommon/ScrollIcon/index.jsx



var Svg = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6778).then(__webpack_require__.bind(__webpack_require__, 6778));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6778)
            ];
        }
    }
});
var ScrollIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).iconWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg, {
            type: "arrowNarrowUp",
            className: (styles_module_default()).scrollDown
        })
    });
};
/* harmony default export */ var HomeCommon_ScrollIcon = (ScrollIcon);

;// CONCATENATED MODULE: ./hooks/useAppearingAnimation.js

function useAppearingAnimation() {
    var isMobileResolution = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var oldYRef = (0,react.useRef)(0);
    var ref = (0,react.useState)(""), direction = ref[0], setDirection = ref[1];
    var ref1 = (0,react.useState)(false), isTopOfPage = ref1[0], setTopOfPage = ref1[1];
    (0,react.useEffect)(function() {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        oldYRef.current = window.pageYOffset;
        var handleOnScroll = function() {
            var pageYOffset = window.pageYOffset;
            if (pageYOffset < 250) {
                setTopOfPage(true);
                if (!isMobileResolution) {
                    if (pageYOffset < 200 && oldYRef.current > pageYOffset) {
                        setDirection("up");
                    }
                    if (pageYOffset > 100 && oldYRef.current < pageYOffset) {
                        setDirection("down");
                    }
                }
            } else {
                setTopOfPage(false);
            }
            oldYRef.current = pageYOffset;
        };
        handleOnScroll();
        window.addEventListener("scroll", handleOnScroll);
        return function() {
            return window.removeEventListener("scroll", handleOnScroll);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return [
        direction,
        isTopOfPage
    ];
}
/* harmony default export */ var hooks_useAppearingAnimation = (useAppearingAnimation);

// EXTERNAL MODULE: ./components/HomeCommon/AddFooter/styles.module.scss
var AddFooter_styles_module = __webpack_require__(91883);
var AddFooter_styles_module_default = /*#__PURE__*/__webpack_require__.n(AddFooter_styles_module);
;// CONCATENATED MODULE: ./components/HomeCommon/AddFooter/index.jsx








var AddFooter = function(param) {
    var theme = param.theme;
    var ref = (0,_sliced_to_array/* default */.Z)(hooks_useAppearingAnimation(), 2), direction = ref[0], isTopOfPage = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: classnames_default()((AddFooter_styles_module_default()).addFooterContainer, (AddFooter_styles_module_default())[direction], (0,_define_property/* default */.Z)({}, (AddFooter_styles_module_default()).notOnTop, !isTopOfPage)),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeCommon_ScrollIcon, {
            theme: theme
        })
    });
};
AddFooter.defaultProps = {
    theme: "dark"
};
AddFooter.propTypes = {
    theme: (prop_types_default()).string
};
/* harmony default export */ var HomeCommon_AddFooter = (AddFooter);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(2664);
// EXTERNAL MODULE: ./redux/selectors/layout.js
var layout = __webpack_require__(19341);
// EXTERNAL MODULE: ./components/Common/LinkWrapper/index.jsx + 1 modules
var LinkWrapper = __webpack_require__(40659);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./components/HomeCommon/IntroText/styles.module.scss
var IntroText_styles_module = __webpack_require__(14806);
var IntroText_styles_module_default = /*#__PURE__*/__webpack_require__.n(IntroText_styles_module);
;// CONCATENATED MODULE: ./components/HomeCommon/IntroText/index.jsx











var IntroText = function(param) {
    var className = param.className;
    var isMobileResolution = (0,es.useSelector)(layout/* selectIsMobile */.eD);
    var ref = (0,_sliced_to_array/* default */.Z)(hooks_useAppearingAnimation(isMobileResolution), 2), direction = ref[0], isTopOfPage = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("intro-text", (IntroText_styles_module_default()).introTextContainer, className, (IntroText_styles_module_default())[direction], (0,_define_property/* default */.Z)({}, (IntroText_styles_module_default()).notOnTop, !isTopOfPage)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (IntroText_styles_module_default()).introText,
                children: "We build AI-first products for clients who change the world."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                isLocalLink: true,
                path: constants/* ROUTES.contact.path */.y2.contact.path,
                dynamicRouting: constants/* ROUTES.contact.dynamicPath */.y2.contact.dynamicPath,
                className: (IntroText_styles_module_default()).introLink,
                children: "Get in touch"
            })
        ]
    });
};
IntroText.defaultProps = {
    className: ""
};
IntroText.propTypes = {
    className: (prop_types_default()).string
};
/* harmony default export */ var HomeCommon_IntroText = (IntroText);

;// CONCATENATED MODULE: ./UI/components/Duck/DuckContainer/utils/useDuckContainer.js

var useDuckContainer = function() {
    var containerText = (0,react.useRef)(null);
    var sloganRef = (0,react.useRef)(null);
    return {
        sloganRef: sloganRef,
        containerText: containerText
    };
};

// EXTERNAL MODULE: ./UI/components/Duck/DuckContainer/styles.module.scss
var DuckContainer_styles_module = __webpack_require__(53079);
var DuckContainer_styles_module_default = /*#__PURE__*/__webpack_require__.n(DuckContainer_styles_module);
;// CONCATENATED MODULE: ./UI/components/Duck/DuckContainer/index.jsx







var Animated = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var DuckWrapper = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 14286).then(__webpack_require__.bind(__webpack_require__, 14286));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14286)
            ];
        }
    }
});
var DuckContainer = function(props) {
    var ref = useDuckContainer(props), sloganRef = ref.sloganRef, containerText = ref.containerText;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (DuckContainer_styles_module_default()).text,
                ref: containerText,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, {
                    type: constants/* ANIMATED_TYPE.isParallaxSpring */.BK.isParallaxSpring,
                    position: "absolute",
                    speed: 0.3,
                    elementRef: containerText,
                    isHomepageIntro: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        ref: sloganRef,
                        className: classnames_default()("letter-container", (DuckContainer_styles_module_default()).slogan),
                        children: constants/* HOMEPAGE_SLOGAN */.Z6
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DuckWrapper, {
                sloganRef: sloganRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeCommon_IntroText, {
                className: (DuckContainer_styles_module_default()).subText
            })
        ]
    });
};
/* harmony default export */ var Duck_DuckContainer = (DuckContainer);

// EXTERNAL MODULE: ./UI/sections/HomeIntro/styles.module.scss
var HomeIntro_styles_module = __webpack_require__(48431);
var HomeIntro_styles_module_default = /*#__PURE__*/__webpack_require__.n(HomeIntro_styles_module);
;// CONCATENATED MODULE: ./UI/sections/HomeIntro/index.jsx






var HomeIntro = function(param) {
    var theme = param.theme, introSection = param.introSection;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        ref: introSection,
        className: (HomeIntro_styles_module_default()).intro,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Duck_DuckContainer, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeCommon_AddFooter, {
                theme: theme
            })
        ]
    });
};
HomeIntro.defaultProps = {
    theme: "dark"
};
HomeIntro.propTypes = {
    theme: (prop_types_default()).string,
    introSection: prop_types_default().instanceOf(Object).isRequired
};
/* harmony default export */ var sections_HomeIntro = (/*#__PURE__*/(0,react.memo)(HomeIntro));

// EXTERNAL MODULE: ./utils/error.js
var utils_error = __webpack_require__(93250);
// EXTERNAL MODULE: ./UI/components/Duck/utils/helpers.js
var helpers = __webpack_require__(60982);
;// CONCATENATED MODULE: ./UI/components/Duck/DuckWrapper/utils/helpers.js




var loadDuck = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        new Promise(function(resolve) {
                            helpers/* three.loadModel */.T.loadModel(resolve); // !
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    error = _state.sent();
                    (0,utils_error/* handleError */.S3)({
                        error: error,
                        message: "Error in the loadDuck function"
                    });
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function loadDuck() {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./components/Common/MetaTags/index.jsx + 3 modules
var MetaTags = __webpack_require__(38067);
// EXTERNAL MODULE: ./utils/appContext.js
var appContext = __webpack_require__(16515);
;// CONCATENATED MODULE: ./containers/Home/index.jsx














var SectionSelector = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 94378).then(__webpack_require__.bind(__webpack_require__, 94378));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(94378)
            ];
        }
    }
});
var Home = function(_param) {
    var theme = _param.theme, introSection = _param.introSection, pageMetadata = _param.pageMetadata, pageData = _param.pageData, type = _param.type, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "introSection",
        "pageMetadata",
        "pageData",
        "type"
    ]);
    var contentModules = pageData;
    var ref = (0,react.useContext)(appContext/* AppContext */.I), duck = ref.contextData.duck, setContextData = ref.setContextData;
    (0,react.useEffect)(function() {
        if (duck) {
            return;
        }
        (0,_async_to_generator/* default */.Z)(function() {
            var duckLoaded;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            loadDuck()
                        ];
                    case 1:
                        duckLoaded = _state.sent();
                        setContextData(function(prev) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                duck: duckLoaded
                            });
                        });
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        duck,
        setContextData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTags/* default */.Z, {
                page: constants/* PAGES.homepage */.q5.homepage,
                pageMetadata: pageMetadata
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_HomeIntro, {
                theme: theme,
                introSection: introSection
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                children: contentModules === null || contentModules === void 0 ? void 0 : contentModules.map(function(module, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionSelector, (0,_object_spread/* default */.Z)({
                        section: module,
                        type: type
                    }, rest), "section/".concat(i));
                })
            })
        ]
    });
};
Home.propTypes = {
    introSection: prop_types_default().instanceOf(Object).isRequired,
    pageMetadata: prop_types_default().instanceOf(Object).isRequired,
    theme: (prop_types_default()).string.isRequired,
    type: (prop_types_default()).string.isRequired
};
/* harmony default export */ var containers_Home = (Home);

;// CONCATENATED MODULE: ./pages/index.js

var __N_SSG = true;
/* harmony default export */ var pages = (containers_Home);


/***/ }),

/***/ 19341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bw": function() { return /* binding */ selectIsSmallTablet; },
/* harmony export */   "Tr": function() { return /* binding */ selectIsPageReadyToDisplay; },
/* harmony export */   "Y6": function() { return /* binding */ selectIsDesktop; },
/* harmony export */   "aT": function() { return /* binding */ selectIsTablet; },
/* harmony export */   "cF": function() { return /* binding */ selectIsFirstPageLoaded; },
/* harmony export */   "eD": function() { return /* binding */ selectIsMobile; },
/* harmony export */   "qL": function() { return /* binding */ selectIsMobileCategotiesOpened; }
/* harmony export */ });
var selectIsMobileCategotiesOpened = function(state) {
    return state.layout.isMobileCategotiesOpened;
};
var selectIsPageReadyToDisplay = function(state) {
    return state.layout.isPageReadyToDisplay;
};
var selectIsFirstPageLoaded = function(state) {
    return state.layout.isFirstPageLoaded;
};
var selectIsMobile = function(state) {
    return state.layout.isMobileResolution;
};
var selectIsTablet = function(state) {
    return state.layout.isTabletResolution;
};
var selectIsSmallTablet = function(state) {
    return state.layout.isSmallTabletResolution;
};
var selectIsDesktop = function(state) {
    return state.layout.isDesktopResolution;
};


/***/ }),

/***/ 53079:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__WXdT1","slogan":"styles_slogan__C5GRj","animate":"styles_animate__LGiHs"};

/***/ }),

/***/ 48431:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"intro":"styles_intro__nVVev"};

/***/ }),

/***/ 81098:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__MXUD5"};

/***/ }),

/***/ 91883:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"addFooterContainer":"styles_addFooterContainer__ZynQo","animate":"styles_animate__sk_rt","down":"styles_down__hkTtb","up":"styles_up__gkyyW","notOnTop":"styles_notOnTop__V_blC","blinking":"styles_blinking__1oTfx","swing":"styles_swing__EgUWy","animateborder":"styles_animateborder__E6c0x","animateborder-overlay":"styles_animateborder-overlay__0BDPd","animatecircle":"styles_animatecircle__LqRJo","animatedot":"styles_animatedot__gPKR0","animStar":"styles_animStar___Xdsz","hideText":"styles_hideText__RgbZY","spin":"styles_spin__JVCUS","outOfTransparencyDesktop":"styles_outOfTransparencyDesktop___HZYH","outOfTransparencyMobile":"styles_outOfTransparencyMobile__3kwJu","appearance":"styles_appearance__SOmgI","appearanceFromBelow":"styles_appearanceFromBelow__C_7Jb","flicker":"styles_flicker___TKmd","vibrate1":"styles_vibrate1__yAfob","rocket":"styles_rocket__x9bzi","burgerItem1":"styles_burgerItem1__WxuOc","burgerItem2":"styles_burgerItem2__H31I3","burgerItem3":"styles_burgerItem3__9Ih9T","burgerItem1Reverse":"styles_burgerItem1Reverse__3V5T8","burgerItem2Reverse":"styles_burgerItem2Reverse__Ww58K","burgerItem3Reverse":"styles_burgerItem3Reverse__1Mp0V","arrow-down":"styles_arrow-down__XYvz_","image-scroll":"styles_image-scroll__C_rpt","image-scroll-reverse":"styles_image-scroll-reverse__h1QK5","stickerbox-pointer-move":"styles_stickerbox-pointer-move__Z7YwJ","hide-image":"styles_hide-image__aXLjI","stickerbox-pointer-second":"styles_stickerbox-pointer-second__xn7fD","stickerbox-pointer-third":"styles_stickerbox-pointer-third__8N0up","cedar-bounce":"styles_cedar-bounce__qKPU5"};

/***/ }),

/***/ 14806:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"introTextContainer":"styles_introTextContainer__tbbUK","introText":"styles_introText__4g0SH","introLink":"styles_introLink__1FrpD","down":"styles_down__AzJLm","up":"styles_up__G_ZbW","notOnTop":"styles_notOnTop__zSv9O"};

/***/ }),

/***/ 21917:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"styles_iconWrapper__YcYvx","scrollDown":"styles_scrollDown__Zdk5W","arrow-down":"styles_arrow-down__5uvzF","blinking":"styles_blinking__QYZaF","swing":"styles_swing__hrikM","animateborder":"styles_animateborder__jJwVX","animateborder-overlay":"styles_animateborder-overlay__7jEU9","animatecircle":"styles_animatecircle__nOBC2","animatedot":"styles_animatedot__1bXO6","animStar":"styles_animStar__td5rf","hideText":"styles_hideText__DLMPA","spin":"styles_spin__9JMfP","outOfTransparencyDesktop":"styles_outOfTransparencyDesktop__NKwnd","outOfTransparencyMobile":"styles_outOfTransparencyMobile__VJt6C","appearance":"styles_appearance__Fv_cE","appearanceFromBelow":"styles_appearanceFromBelow__KT_K_","flicker":"styles_flicker__ad6R0","vibrate1":"styles_vibrate1__pYfkH","rocket":"styles_rocket__Lnq1e","burgerItem1":"styles_burgerItem1__7Ak6b","burgerItem2":"styles_burgerItem2__QCvzg","burgerItem3":"styles_burgerItem3__Os_04","burgerItem1Reverse":"styles_burgerItem1Reverse__1dF2Y","burgerItem2Reverse":"styles_burgerItem2Reverse__v3IYf","burgerItem3Reverse":"styles_burgerItem3Reverse__egYZT","image-scroll":"styles_image-scroll__A7yPH","image-scroll-reverse":"styles_image-scroll-reverse__j1_cP","stickerbox-pointer-move":"styles_stickerbox-pointer-move__DWsxM","hide-image":"styles_hide-image__eL0ff","stickerbox-pointer-second":"styles_stickerbox-pointer-second__T5l_9","stickerbox-pointer-third":"styles_stickerbox-pointer-third__K83mc","cedar-bounce":"styles_cedar-bounce__hs1MM"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [43737,90014,13107,49774,92888,40179], function() { return __webpack_exec__(75557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);